import { render, staticRenderFns } from "./kachelgroesse_select.vue?vue&type=template&id=5b6441ca"
import script from "./kachelgroesse_select.vue?vue&type=script&lang=js"
export * from "./kachelgroesse_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports